import { Text, Flex, TooltipText, useTooltip, Skeleton, Heading, Box, Button } from '@pancakeswap/uikit'
import { useEffect, useState } from 'react'
// import Balance from 'components/Balance'
import styled, { keyframes, css } from 'styled-components'
import Balance from '../../../../../components/Balance';
import { getContract } from "utils/contractHelpers";
import DrivenStakingABI from "ABI/DrivenStakingABI.json";
import DrivenLockupABI from "ABI/DrivenLockupABI.json";
import DrivenFarmABI from "ABI/DrivenFarmABI.json";
import {
    getDrivenFarmAddress,
    getLockUpAddress,
} from "utils/addressHelpers";
import { useWeb3React } from '@web3-react/core';
import { useLocation } from 'react-router-dom'
import { ethers } from 'ethers';
import { useDispatch, useSelector } from 'react-redux';
import { setPidx } from 'store/IndexSlice';
import LoopIcon from '@mui/icons-material/Loop';


interface FarmAutoHarvestActionProps {
    pool: any
}

export const ActionContainer = styled.div<{ isAutoVault?: boolean }>`
  padding: 16px;
  border: 2px solid ${({ theme }) => theme.colors.input};
  border-radius: 16px;
  flex-grow: 1;
  flex-basis: 0;
  margin-bottom: 16px;

  ${({ theme }) => theme.mediaQueries.sm} {
    margin-left: 12px;
    margin-right: 12px;
    margin-bottom: 0;
    height: auto;
  }

`

export const ActionTitles = styled.div`
  font-weight: 600;
  font-size: 12px;
`

export const ActionContent = styled.div`
    /* padding: 16px; */
    -webkit-box-flex: 1;
    flex-grow: 1;
    flex-basis: 0px;
    margin-bottom: 16px;
`

const Earned = styled.div`
    font-weight: 600;
    font-size: 12px;
    padding-top: 10px;
    display: flex;
    /* justify-content: space-around; */
    text-transform: uppercase;
    
`

const Compound = styled.div`
    display: flex;
    -webkit-box-pack: justify;
    justify-content: space-between;
    -webkit-box-align: center;
    align-items: center;
`

const CompoundButtoon = styled(Button)`
    background-color: #00FED9;
    color : #000000;
    border-color: rgb(233, 234, 235);
    box-shadow: none;
    // cursor: not-allowed;
    align-items: center;
    border: 0px;
    border-radius: 16px;
    display: inline-flex;
    font-family: inherit;
    font-size: 16px;
    font-weight: 600;
    -webkit-box-pack: center;
    justify-content: center;
    letter-spacing: 0.03em;
    line-height: 1;
    opacity: 1;
    outline: 0px;
    transition: background-color 0.2s ease 0s, opacity 0.2s ease 0s;
    margin-bottom: 4px;
    height: auto;
    padding: 5px 10px;
    font-size: 12px;
`
const HarvestButton = styled(Button)`
    align-items: center;
    border: 0px none;
    border-radius: 16px;
    box-shadow: rgba(14, 14, 44, 0.4) 0px -1px 0px 0px inset;
    cursor: pointer;
    display: inline-flex;
    font-family: inherit;
    font-size: 16px;
    font-weight: 600;
    -moz-box-pack: center;
    justify-content: center;
    letter-spacing: 0.03em;
    line-height: 1;
    opacity: 1;
    outline: currentcolor none 0px;
    transition: background-color 0.2s ease 0s, opacity 0.2s ease 0s;
    height: 48px;
    padding: 0px 24px;
    background-color: #00FED9;
    color: black;
    margin-left: 4px;
`
const Buttons = styled(Box)`
    display: flex;
    flex-direction: column;
`
const FarmAutoHarvest: React.FunctionComponent<FarmAutoHarvestActionProps> = ({ pool }) => {

    const location = useLocation();

    const [disabledbutton, setDisabledButton] = useState(true);


    const { error, connector, activate, deactivate, library, active, account } = useWeb3React();

    const dispatch = useDispatch();
    const pidx = useSelector((state: any) => state.Index.processidx);
    // const [loading, setLoading] = useState(false);
    // useEffect(() => {
    //     if (account) {
    //         const lockUpAddress = getLockUpAddress();
    //         const lockUpContract = getContract(DrivenLockupABI, lockUpAddress, library.getSigner());
    //     }
    // }, [account]);
    useEffect(() => {
        if (account) {
            setDisabledButton(false)
        }
    }, [account]);
    const farmAddress = getDrivenFarmAddress();

    const harvest = async () => {
        setDisabledButton(true);

        try {
            let tx;
            const farmContract = getContract(DrivenFarmABI, farmAddress, library.getSigner()); 
            tx = await farmContract.deposit(pool.pId,  0);
            await tx.wait();
            dispatch(setPidx(pidx + 1))
        } catch (err) {
            console.log(err);
        }
        setDisabledButton(false);

    }

    // const earningTokenBalance = autoCakeToDisplay
    // const earningTokenDollarBalance = autoUsdToDisplay
    // const hasEarnings = hasAutoEarnings

    const { targetRef, tooltip, tooltipVisible } = useTooltip(
        ('Subtracted automatically from each yield harvest and burned.'),
        { placement: 'bottom-start' },
    )



    return (
        // <ActionContainer isAutoVault>
        <Box>
            <ActionContent>
                <Earned>
                    <ActionTitles>
                        <Text fontSize="14px" bold color='#00FED9' as="span" textTransform="uppercase">
                            {"DVX"}{" "}
                        </Text>
                        <Text fontSize="14px" bold color="#00FED9" as="span" textTransform="uppercase">
                            {('Earned')} {' '}
                        </Text>
                    </ActionTitles>


                </Earned>
                <Compound>

                    <Box mr="8px" height="32px">

                        <Balance
                            // display="inline"
                            fontSize="16px"
                            decimals={2}
                            prefix=""
                            color="white"
                            // value={pool.user.pendingreward}
                            value={pool.user && pool?.lpTokenDecimal ? parseInt(ethers.utils.formatUnits(pool.user?.pendingreward, pool?.lpTokenDecimal).toString()) : 0}
                            unit=""
                        />
                    </Box>
                    <Buttons>

                        <HarvestButton onClick={() => harvest()} disabled={!active || disabledbutton || pool.user?.pendingreward <= 0}>
                            Harvest {!active || disabledbutton && <Box><LoopIcon className="animation-spin" sx={{ width: '18px', height: '18px' }} /></Box>}
                        </HarvestButton>

                    </Buttons>
                </Compound>


            </ActionContent>
        </Box>
        // </ActionContainer>
    )
}

export default FarmAutoHarvest
